import React, { useState, useEffect, useCallback, useMemo, memo } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import TimelineBar from './TimelineBar';
import './DriverScheduleTable.scss';
import { getServices } from '../MaestroDeServiciosIntegracion';
import DriverDetailModal from './DriverDetailModal';
import UnitDetailModal from './UnitDetailModal';
import SummaryTable from './SummaryTable.jsx';
import RealTimeTrackingModal from './RealTimeTrackingModal';
import Swal from 'sweetalert2';

const DriverScheduleTable = ({ params, fetchDriversData, driversData, loading, zona, selectedFilterType, selectedColumns, setKmCalculado, kmCalculado }) => {



    // parametros


    const [idOperatorForModal, setIdOperatorForModal] = useState(null); // Estado para el ID del operador a mostrar en el modal
    const [modalVisible, setModalVisible] = useState(false); // Estado para controlar la visibilidad del modal
    const [idUnitForModal, setIdUnitForModal] = useState(null);
    const [modalUnitVisible, setModalUnitVisible] = useState(false);
    const [trackingModalVisible, setTrackingModalVisible] = useState(false);
    const [selectedTrackingData, setSelectedTrackingData] = useState({ operadorId: null, unidadId: null, operador: null });
    const rowHeight = 45;


    useEffect(() => {
        fetchDriversData(params);
    }, [fetchDriversData]);

    const timelineHeaderTemplate = useCallback(() => {
        const hours = [];
        for (let i = 0; i < 24; i++) {
            const hourLabel = i.toString().padStart(2, '0');
            hours.push(
                // Aquí, el flex-grow en el CSS ya se encarga de la distribución
                <div key={`header-hour-${i}`} className="timeline-column-header-hour">
                    {hourLabel}
                </div>
            );
        }
        return (
            <div className="timeline-column-header">
                {hours}
            </div>
        );
    }, []);

    const detailBodyTemplate = (rowData) => {

        return <TimelineBar servicesConcatenated={rowData.SERVICIOS_CONCATENADOS} estatus={rowData.ESTATUS} selectedFilterType={selectedFilterType} consultedDate={params?.fecha} />;
    };
    const clickOperador = (rowData) => {
        return (
            <>
                <div className="operadorClick" onClick={() => { handleOperadorClick(rowData) }}>
                    {rowData.NOMBRE}
                </div>
            </>
        )
    }
    const diferenciaKm = (rowData) => {
        return (
            <>
                <div className="operadorClick" >
                    {rowData.KM_CALCULADO - rowData.KM} km
                </div>
            </>
        )
    }
    const handleOperadorClick = (rowData) => {
        setIdOperatorForModal(rowData.ID); // Establece el ID del operador
        setModalVisible(true); // Abre el modal
        // Aquí NO necesitas hacer la petición a la API. El modal se encargará de eso
        // cuando detecte que visible y idOperatorForModal han cambiado.
    };
    const hideModal = () => {
        setModalVisible(false);
        setIdOperatorForModal(null); // Limpiar el ID al cerrar el modal
    };

    // *** NUEVA FUNCIÓN para renderizar el número de unidad y manejar el clic ***
    const clickUnidad = (rowData) => {
        return (
            <div className="operadorClick" onClick={() => handleUnidadClick(rowData)}>
                {rowData.UNIDAD}
            </div>
        );
    }
    // *** NUEVA FUNCIÓN para manejar el clic en la unidad ***
    const handleUnidadClick = (rowData) => {
        setIdUnitForModal(rowData.UNIDAD); // Asumiendo que 'UNIDAD' es el ID numérico de la unidad
        setModalUnitVisible(true); // Abre el modal de unidad
    };

    // *** NUEVA FUNCIÓN para ocultar el modal de unidad ***
    const hideUnitModal = () => {
        setModalUnitVisible(false);
        setIdUnitForModal(null);
    };

    // Función para manejar clic en KM Calculado
    const clickKmCalculado = (rowData) => {
        return (
            <div
                className="operadorClick"
                onClick={() => handleKmCalculadoClick(rowData)}
                style={{ cursor: 'pointer', color: '#0078d4', fontWeight: 'bold' }}
            >
                {rowData.KILOMETRAJE_WIALON?.length > 0 ? `${rowData.KILOMETRAJE_WIALON[2]}` : '-'}
            </div>
        );
    };

    // Función para abrir el modal de seguimiento
    const handleKmCalculadoClick = (rowData) => {
        
        if (rowData.KILOMETRAJE_WIALON.length >0) {
            setSelectedTrackingData({
                operadorId: rowData.ID,
                unidadId: rowData.UNIDAD,
                operador: rowData.NOMBRE,
            });
            setTrackingModalVisible(true);
        }
        else{
             setTrackingModalVisible(false);
             Swal.fire({
                icon: 'info',
                title: 'Sin Kilometraje Calculado',
                text: 'No hay kilómetro calculado disponible para esta unidad.'
            });
        }
    };

    // Función para cerrar el modal de seguimiento
    const hideTrackingModal = () => {
        setTrackingModalVisible(false);
        setSelectedTrackingData({ operadorId: null, unidadId: null, operador: null });
    };

    
    return (
        <div className="card padding-table-master-of-services">
            {
                zona == 'maestro' ?
                    <DataTable
                        value={driversData}
                        responsiveLayout="scroll"
                        emptyMessage="No se encontraron datos de operadores."
                        loading={loading}
                        scrollable
                        virtualScroll
                        virtualScrollOptions={{ itemSize: rowHeight }}
                        scrollHeight="flex"
                    >
                        {
                            selectedColumns.map((col) => {
                                if (col.code === 'ID' && params.selectedFilterType === 'operador') {
                                    return <Column key={col.code} visible={params.selectedFilterType === 'operador'} field="ID" header="ID" style={{ width: '80px', textAlign: 'center' }}></Column>;
                                }
                                if (col.code === 'OPERADOR' && params.selectedFilterType === 'operador') {
                                    return <Column key={col.code} visible={params.selectedFilterType === 'operador'} field="NOMBRE" header="OPERADOR" body={clickOperador} style={{ minWidth: '150px' }}></Column>;
                                }
                                if (col.code === 'UNIDAD') {
                                    return <Column key={col.code} field="UNIDAD" header="UNIDAD" body={clickUnidad} style={{ minWidth: '70px' }}></Column>;
                                }
                                if (col.code === 'UNIDAD_TIPO' && params.selectedFilterType !== 'ruta') {
                                    return <Column key={col.code} field="UNIDAD_TIPO" header="TIPO UNIDAD" style={{ minWidth: '70px' }}></Column>;
                                }
                                if (col.code === 'SERVICIOS') {
                                    return <Column key={col.code} field="SERVICIOS" header="#SER" style={{ width: '70px', textAlign: 'center' }}></Column>;
                                }
                                if (col.code === 'HORAS') {
                                    return <Column key={col.code} field="HORAS" header="HORAS" style={{ width: '80px', textAlign: 'center' }}></Column>;
                                }
                                if (col.code === 'RUTA' && params.selectedFilterType === 'ruta') {
                                    return <Column key={col.code} field="RUTA" header="RUTA" style={{ width: '200px', textAlign: 'center' }}></Column>;
                                }
                                if (col.code === 'KM') {
                                    return <Column key={col.code} field="KM" header="KM RUTA" style={{ width: '100px', textAlign: 'right' }}></Column>;
                                }
                               
                                if (col.code === 'KM_CALCULADO') {
                                    return (
                                        <Column
                                            key={col.code}
                                            field="KILOMETRAJE_WIALON"
                                            header="KM CALCULADO"
                                            body={clickKmCalculado}
                                            style={{ width: '120px', textAlign: 'center' }}
                                        />
                                    );
                                }
                                 if (col.code === 'KM_CALCULADO') {
                                    return <Column key={col.code} field="DIFERENCIA_KM" header="DIFERENCIA EN KM" style={{ width: '100px', textAlign: 'right' }} body={diferenciaKm}></Column>;
                                }
                                if (col.code === 'PAGO') {
                                    return <Column key={col.code} field="PAGO" header="PAGO" style={{ width: '90px', textAlign: 'right' }}></Column>;
                                }
                                if (col.code === 'ESTATUS' && params.selectedFilterType === 'operador') {
                                    return <Column key={col.code} visible={params.selectedFilterType === 'operador'} field="ESTATUS" header="ESTATUS" style={{ width: '120px' }}></Column>;
                                }
                                return null; // Si la columna no coincide con ninguna condición, no renderiza nada
                            })
                        }

                        <Column
                            header={timelineHeaderTemplate}
                            body={detailBodyTemplate}
                            className="timeline-column-cell"
                            style={{ minWidth: '1000px', flexShrink: 0 }} // Por ejemplo, 1000px o más, y evitar que se encoja
                        ></Column>
                    </DataTable> :
                    <div style={{ marginTop: '20px' }}> {/* Espacio entre las tablas */}
                        <SummaryTable driversData={driversData} />
                    </div>

            }
            <UnitDetailModal
                idUnit={idUnitForModal}
                visible={modalUnitVisible}
                onHide={hideUnitModal}
            />
            <DriverDetailModal
                idOperator={idOperatorForModal}
                visible={modalVisible}
                onHide={hideModal}
            />
            <RealTimeTrackingModal
                visible={trackingModalVisible}
                onHide={hideTrackingModal}
                operadorId={selectedTrackingData.operadorId}
                operador={selectedTrackingData.operador}
                unidadId={selectedTrackingData.unidadId}
                fecha={params.fecha}
            />
        </div>
    );
};

export default DriverScheduleTable;